import { useEffect, useState } from "react";
import { Checkbox } from "antd";
import axiosInstance from "../variables/api/axiosInstance";
import { rightsService } from "../services/rightsService";

/**
 * Case « membre du personnel » — n'apparaît QUE si l'utilisateur a l'habilitation HCO090.
 * Au changement, remonte (checked, maxPersonnel) au parent : à charge du parent de positionner
 * le bonus au max personnel (par défaut) puis de l'éditer à la baisse, et d'envoyer
 * `membrePersonnel` dans le payload. Le plafond max personnel est lu côté Pool.
 */
const MembrePersonnelCheck = ({
    checked,
    onToggle,
    disabled = false,
    label = "Contrat appartenant à un membre du personnel",
}) => {
    const [maxPersonnel, setMaxPersonnel] = useState(50);
    const allowed = rightsService("HCO090");

    useEffect(() => {
        if (!allowed) return;
        axiosInstance
            .get("/api/parametre/plafond-bonus-personnel")
            .then((res) => {
                const v = Number(res.data);
                if (!Number.isNaN(v) && v > 0) setMaxPersonnel(v);
            })
            .catch(() => { /* défaut 50 conservé */ });
    }, [allowed]);

    if (!allowed) return null;

    return (
        <Checkbox
            checked={!!checked}
            disabled={disabled}
            onChange={(e) => onToggle && onToggle(e.target.checked, maxPersonnel)}
        >
            {label}
        </Checkbox>
    );
};

export default MembrePersonnelCheck;
